import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import LoginPage from './views/LoginPage';
import DashboardPage from './views/DashboardPage';
import UsersPage from './views/UsersPage';
import UserDetailPage from './views/UserDetailPage';
import OrganizationsPage from './views/OrganizationsPage';
import OrganizationDetailPage from './views/OrganizationDetailPage';
import FeaturesPage from './views/FeaturesPage';
import NdasPage from './views/NdasPage';
import AgreementsPage from './views/AgreementsPage';
import ExportPage from './views/ExportPage';
import NotificationsPage from './views/NotificationsPage';

// Protected routea wraappera
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh' 
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated || !isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="users/:userId" element={<UserDetailPage />} />
        <Route path="organizations" element={<OrganizationsPage />} />
        <Route path="organizations/:orgId" element={<OrganizationDetailPage />} />
        <Route path="ndas" element={<NdasPage />} />
        <Route path="agreements" element={<AgreementsPage />} />
        <Route path="features" element={<FeaturesPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="export" element={<ExportPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;

